import React from 'react';
import { Logo as Logo$1 } from '@sravni/react-design-system/lib/Logo';
import { useStyles } from '@sravni/react-utils';
import modules_997b7aad from '../styles/Logo.module.less.js';

const Logo = ({ logoUrl, className, onClick, ...rest }) => {
    const cx = useStyles(modules_997b7aad);
    return (React.createElement("a", { "data-element": "footer-logo-link", href: logoUrl ?? '/', onClick: onClick, className: cx(className, 'logoLink'), "aria-label": "\u041B\u043E\u0433\u043E\u0442\u0438\u043F", ...rest },
        React.createElement(Logo$1, { className: modules_997b7aad.logo })));
};
Logo.displayName = 'Logo';

export { Logo };
//# sourceMappingURL=Logo.js.map
